import Vue from 'vue'
import Router from 'vue-router'
import api from '../api/api'
import header from '@/components/header'
import side from '@/components/side'
import main from '@/view/main'
import statistics from '@/view/statistics'
import statisticsDay from '@/view/statistics-day'

Vue.use(Router);
const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      components: {
        header :header,
        side :side,
        main:main
      }
    },{
      path: '/statistics',
      components: {
        header :header,
        side :side,
        main:statistics
      }
    },{
      path: '/statistics/day',
      components: {
        header :header,
        side :side,
        main:statisticsDay
      }
    }
  ]
});
/*router.beforeEach((to, from, next) => {
  if (to.meta.requireAuth) {
    next()
  }else {
    next()
  }
});*/
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js